import React, { Component, useRef, useMemo, useState, useEffect } from "react";
import ReactLoading from 'react-loading';
import moment from "moment";
import { useTable, useExpanded } from "react-table";
import { getToken } from "../../../utils/common";
import { useHistory } from "react-router-dom";

export default function ShowPreview({
    firstname,
    lastName,
    number,
    email,
    country,
    selectNight,
    roomSelected,
    itinerariesDetails,
    itineraryindexValue,
    adultCount,
    infantCount,
    childCount,
    handleModify,
    handleSendMulti,
    inquary,
    sendLoad,
    requestSlectedTotal,
    requestSlectedTCS,
    requestSlectedGST,
    promoCode,
    requestSelected,
    additionalRequirement,
    city,
    nri,
    leadStatus,
    priority,
    callbackdate,
    panNumber,
    state,
    department,
    itineraryindex,
    requestSlectedPrice,
    addCabinCounted,
    safetyPlan,
    isSafetyPlanSelected,
}) {

    console.log(addCabinCounted)
    console.log(childCount)
    let history = useHistory();
    const [loading, setLoading] = useState(false);

    var grandCabinTotal = 0;
    const totalAmount = roomSelected.map((data) => {
        grandCabinTotal = grandCabinTotal + data.price.total
    })

    var priceDataArray = [];

    roomSelected.map((data) => {
        priceDataArray.push(
            {
                "cabin": data.name,
                "cabin_price": data.price.cabin_fare,
                "port_charges": data.price.port_charges,
                "gratuity": data.price.gratuity,
                "fuel_surcharge": data.price.fuel_surcharge,
                "gst": data.price.gst,
                "tcs": data.price.tcs != undefined ? data.price.tcs : 0,
                "special_request": requestSlectedTotal - requestSlectedGST - requestSlectedTCS,
                "discount": data.price.discount == null ? 0 : data.price.discount,
                "safety_protection": isSafetyPlanSelected ? parseInt(safetyPlan.plan_total) : 0,
                "total_price": isSafetyPlanSelected ? parseInt(safetyPlan.plan_total) + parseInt(data.price.total) : data.price.total,
                "actual_total_price": isSafetyPlanSelected ? parseInt(safetyPlan.plan_total) + parseInt(data.price.actual_total) : data.price.actual_total,
            }
        )
    })

    const handleSendButton = () => {
        setLoading(true)
        var arrayRooms = [];
        var obj;
        roomSelected.map((data) => {
            arrayRooms.push([{
                priceKey: data.priceKey
            }])
        })

        var sendingValue = {
            first_name: firstname,
            last_name: lastName,
            phone_number: number,
            pan: panNumber,
            email: email,
            country: country,
            state: state,
            number: inquary,
            city: city,
            nri: nri,
            lead_status: leadStatus,
            priority: priority,
            callback_time: callbackdate,
            department: department,
            promoCode: promoCode,
            special_reqst_total: requestSlectedTotal,
            special_reqst_gst: requestSlectedGST,
            special_reqst_tcs: requestSlectedTCS,
            special_reqst: requestSelected,
            additional_requirement: additionalRequirement,
            special_reqst_price: requestSlectedPrice,
            rooms: arrayRooms,
            plan_enabled: isSafetyPlanSelected,
            plan_id: safetyPlan.plan_id
        }

        console.log(sendingValue, 'sendingValue')



        fetch(process.env.REACT_APP_API_ENDPOINT + '/staff_portal/enquiries', {
            method: 'POST',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization:
                    `Bearer ${getToken()}`,
            },
            body: JSON.stringify(sendingValue)
        }).then((response) => {
            if (response.ok) {
                return response.json()
            }
            throw Error("Verification failed");
        }
        ).then((response) => {
            console.log(response)
            setLoading(false)
            if (response.status == "Success") {
                // requestObj = new Object;
                alert("Share Quotation forwarded successfully!!!")
                history.push({
                    pathname: '/admin/dashboard',
                })

            } else {
                alert("Share Quotation forwarded failed!!!")
            }
        })
    }


    const columns = React.useMemo(
        () => [
            {
                Header: 'Cabin',
                accessor: 'cabin',
                maxWidth: 150,
                Cell: (props) => {
                    return <p style={{ textAlign: 'center' }} className="font-bold text-black text-center">{props.value}</p>
                }
            },
            {
                Header: 'Cabin Price',
                accessor: 'cabin_price',
                Cell: (props) => {
                    return <p style={{ wordBreak: 'break-word', textAlign: 'center' }} className="text-black text-center">{props.value}</p>
                }
            },
            {
                Header: 'Service Charges & Levies',
                accessor: 'port_charges',
                Cell: (props) => {
                    return (<>
                        <div className="flex justify-center text-black text-center" style={{ textAlign: 'center' }}>{props.value + props.row.original.gratuity}</div>
                    </>)
                },
            },
            {
                Header: 'Fuel Surcharge',
                accessor: 'fuel_surcharge',
                width: 60,
                Cell: (props) => {
                    return (<>
                        <div className="flex justify-center text-black text-center" style={{ textAlign: 'center' }}>{props.value}</div>
                    </>)
                },
            },
            {
                Header: 'GST',
                accessor: 'gst',
                width: 60,
                Cell: (props) => {
                    return (<>
                        <div className="flex justify-center text-black text-center" style={{ textAlign: 'center' }}>{props.value}</div>
                    </>)
                },
            },
            // {
            //     Header: 'TCS',
            //     accessor: 'tcs', 
            //     width: 60,
            //     Cell: (props) => {
            //       return (<>
            //           <div className="flex justify-center text-black text-center" style={{textAlign:'center'}}>{props.value}</div>
            //       </>)
            //     },
            // },
            {
                Header: 'Discount',
                accessor: 'discount',
                width: 60,
                Cell: (props) => {
                    return (<>
                        <div className="flex justify-center text-j-green text-center" style={{ textAlign: 'center' }}>{props.value != 0 ? '-' : null} {props.value}</div>
                    </>)
                },
            },
            {
                Header: 'Safety Protection',
                accessor: 'safety_protection',
                width: 60,
                Cell: (props) => {
                    return (<>
                        <div className="flex justify-center text-black">{props.value}</div>
                    </>)
                },
            },
            {
                Header: 'Total Price',
                accessor: 'total_price',
                width: 60,
                Cell: ({ row }) => {
                    return (<>
                        {itinerariesDetails[itineraryindex].discount_pct != 0 ?
                            <div className="flex justify-center text-black text-center font-sm line-through" style={{ textAlign: 'center' }}>{Math.floor(row.original.actual_total_price)}</div>
                            : null
                        }
                        <div className="flex justify-center text-black text-center" style={{ textAlign: 'center' }}>{row.original.total_price}</div>
                    </>)
                },
            },

        ],
        []
    )

    let data = priceDataArray;
    const tableInstance = useTable({ columns, data })
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        visibleColumns,
    } = tableInstance

    return (
        <div className="m-12">
            <div className="grid grid-cols-2">
                <div>
                    <p className="text-lg font-bold text-gray-500">Preview</p>
                </div>
                <div className="w-full">
                    <p className="text-sm text-right">Inquiry No: {inquary}</p>
                </div>
            </div>
            <div className="grid grid-cols-2">
                <div className="mt-4">
                    <p className="text-sm font-bold">First Name: <span className="text-sm font-normal">{firstname}</span></p>
                    <p className="text-sm font-bold">Last Name: <span className="text-sm font-normal">{lastName}</span></p>
                    <p className="text-sm font-bold">Email ID: <span className="text-sm font-normal">{email}</span></p>
                    <p className="text-sm font-bold">Contact Number: <span className="text-sm font-normal">{number}</span></p>
                </div>
                <div className="flex justify-end mt-4">
                    <button
                        className="h-10 items-center rounded transition duration-300 ease-in-out bg-white text-center text-black border-red-700 border ml-4 mr-4 pl-4 pr-4"
                        onClick={(e) => handleModify(e)}
                        disabled={loading}
                    >
                        Modify
                    </button>
                    <button
                        className={loading ? "h-10 items-center rounded transition duration-300 ease-in-out bg-gray-500 text-center text-white ml-4 mr-4 pl-6 pr-6" : "h-10 items-center rounded transition duration-300 ease-in-out bg-j-orange text-center text-white ml-4 mr-4 pl-6 pr-6"}
                        onClick={(e) => handleSendButton(e)}
                        disabled={loading}
                    >
                        {loading ? <ReactLoading type={'spinningBubbles'} color={'white'} height={'100%'} width={'40px'} className="p-2" /> : "Send"}
                    </button>
                </div>
            </div>
            <p className="text-md mt-4 mb-4">Quotation Details</p>
            <div className="grid grid-cols-2 border-b-2 pb-6 border-gray-700">
                <div className="border-r-2 border-gray-600">
                    <div className="flex">
                        <div className="w-4/12">
                            <p className="text-sm">Nights:</p>
                        </div>
                        <div className="w-8/12">
                            <p className="text-sm">{selectNight}</p>
                        </div>
                    </div>
                    <div className="flex">
                        <div className="w-4/12">
                            <p className="text-sm">Itinerary:</p>
                        </div>
                        <div className="w-8/12">
                            <p className="text-sm">{itinerariesDetails[itineraryindex].cruice_name}</p>
                        </div>
                    </div>
                    <div className="flex">
                        <div className="w-4/12">
                            <p className="text-sm">Departure:</p>
                        </div>
                        <div className="w-8/12">
                            <p className="text-sm">{itinerariesDetails[itineraryindex].Departure}, {moment(itinerariesDetails[itineraryindex].departure_date).format("DD-MMMM-YYYY")}</p>
                        </div>
                    </div>
                    <div className="flex">
                        <div className="w-4/12">
                            <p className="text-sm">Arrival:</p>
                        </div>
                        <div className="w-8/12">
                            <p className="text-sm">{itinerariesDetails[itineraryindex].destination}, {moment(itinerariesDetails[itineraryindex].rem_obj.endTime).format("DD-MMMM-YYYY")}</p>
                        </div>
                    </div>
                    {/* <div className="flex">
                        <div className="w-4/12">
                            <p className="text-sm">Halt:</p>
                        </div>
                        <div  className="w-8/12">
                            {itinerariesDetails[itineraryindex].rem_obj.ports.map((data)=>{
                                return <span className="text-sm border-r border-black pr-2"></span>
                            })}
                        </div>
                    </div> */}
                </div>
                <div className="pl-4">
                    <div className="flex">
                        <div className="w-4/12">
                            <p className="text-sm">Cabins:</p>
                        </div>
                        <div className="w-8/12">
                            <p className="text-sm">
                                {roomSelected.map((data) => {
                                    return (<span>
                                        {data.name},
                                    </span>)
                                })}
                            </p>
                        </div>
                    </div>
                    <div className="flex">
                        <div className="w-4/12">
                            <p className="text-sm">Guests:</p>
                        </div>
                        <div className="w-8/12">
                            <p className="text-sm">
                                {addCabinCounted.map((data, i) => {
                                    return (
                                        <>
                                            <span>{data.adults + data.infants + data.children}</span>
                                            {i != addCabinCounted.length - 1 && <span>,</span>}
                                        </>
                                    )
                                })}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className="w-full lg:w-5/6">
                    <div className="bg-white shadow-lg rounded my-4">
                        <table class="w-full table-auto">
                            <thead>
                                {headerGroups.map((headerGroup) => (
                                    <tr class="bg-white text-j-magenta text-sm" {...headerGroup.getHeaderGroupProps()}>
                                        {headerGroup.headers.map((column) => (
                                            <th class="py-3 px-6 text-center"
                                                {...column.getHeaderProps({
                                                    style: { maxWidth: column.maxWidth }
                                                })}>{column.render("Header")}</th>
                                        ))}
                                    </tr>
                                ))}
                            </thead>
                            <tbody class="text-gray-600 text-sm font-light" {...getTableBodyProps()}>
                                {(rows.map((row, i) => {
                                    prepareRow(row);
                                    return (
                                        <React.Fragment>
                                            <tr class="border-b border-gray-200 hover:bg-gray-100" {...row.getRowProps()}>
                                                {row.cells.map((cell) => {
                                                    return (
                                                        <td class="py-3 px-6 text-center text-gray-900" {...cell.getCellProps()}>
                                                            {cell.render("Cell")}
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                        </React.Fragment>
                                    )
                                }))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div>
                    <div className="w-fulf grid grid-cols-5 justify-end pt-4 text-right">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div>
                            <p className="pl-4 text-lg pr-4" style={{ paddingTop: '6.2px', fontSize: '14px' }}>Special Request : </p>
                            <p className="pl-4 font-bold text-lg pr-4 " style={{ paddingTop: '6.2px', fontSize: '16px' }}>Grand Total : </p>
                        </div>
                        <div>
                            <div>
                                <p className="w-full text-center pt-2 text-right" style={{ fontSize: '14px' }}> &#x20B9;{Math.round(requestSlectedTotal)}</p>
                            </div>
                            <div>
                                <p
                                    className="w-full text-center font-bold pt-0 text-right"
                                    style={{ fontSize: "16px" }}
                                >
                                    {" "}
                                    &#x20B9;
                                    {Math.round(
                                        isSafetyPlanSelected
                                            ? grandCabinTotal +
                                            requestSlectedTotal +
                                            (parseInt(safetyPlan.plan_total) *
                                                roomSelected.length)
                                            : grandCabinTotal + requestSlectedTotal
                                    )}
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* <div className="grid grid-cols-4 gap-4 mt-6">
                {roomSelected.map((data,i) => {
                    return(<div className="border shadow-xl rounded-xl p-4">
                        <p>Cabin {i+1}</p>
                        <p className="text-j-magenta font-bold pb-1">{data[1].name}</p>
                        <div className="flex mt-2">
                            <div className="w-6/12 text-sm">
                                Cabin Price:
                            </div>
                            <div className="w-6/12 text-sm">
                            &#x20B9;{Math.round(data[1].price.cabin_fare)}
                            </div>
                        </div>
                        <div className="flex mt-2">
                            <div className="w-6/12 text-sm">
                                Service Charges & Levies
                            </div>
                            <div className="w-6/12 text-sm">
                                &#x20B9;{Math.round(data[1].price.port_charges+data[1].price.gratuity)}
                            </div>
                        </div>
                        <div className="flex mt-2">
                            <div className="w-6/12 text-sm">
                                GST:
                            </div>
                            <div className="w-6/12 text-sm">
                            &#x20B9;{Math.round(data[1].price.gst+requestSlectedGST)}
                            </div>
                        </div>
                        {data[1].price.tcs != undefined && <div className="flex mt-2">
                            <div className="w-6/12 text-sm">
                                TCS:
                            </div>
                            <div className="w-6/12 text-sm">
                            &#x20B9;{Math.round(data[1].price.tcs+requestSlectedTCS)}
                            </div>
                        </div>}
                        <div className="flex mt-2">
                            <div className="w-6/12 text-sm">
                                Special Request:
                            </div>
                            <div className="w-6/12 text-sm">
                            &#x20B9;{Math.round(requestSlectedTotal-requestSlectedGST-requestSlectedTCS)}
                            </div>
                        </div>
                        <div className="flex mt-2">
                            <div className="w-6/12 text-sm">
                                Discount:
                            </div>
                            <div className="w-6/12 text-sm">
                            &#x20B9;{Math.round(data[1].price.discount==null?0:data[1].price.discount)}
                            </div>
                        </div>
                        <div className="flex mt-2">
                            <div className="w-6/12 font-bold">
                                Total Price:
                            </div>
                            <div className="w-6/12 font-bold">
                                &#x20B9;{Math.round(data[1].price.total+requestSlectedTotal)}
                            </div>
                        </div>
                    </div>)
                })}
            </div> */}
        </div>
    )
}